import React from "react";
// Customizable Area Start
import {
  createTheme,
  ThemeProvider,
  styled,
} from '@mui/material/styles';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { capitalizeFirstLetter } from "../../../components/src/utils"

export const theme = createTheme({
  typography: {
    fontFamily: "Montserrat !important",
    h1: {
      fontSize: "24px",
      fontWeight: "500",
      lineHeight: "29.26px",
      color: "#0F172A",
    },
    body1: {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "19.5px",
      color: "#1E293B",
    }
  }
});


import MyOrdersController, {
  Props,
} from "./MyOrdersController.web";
import NavigationMenu from "../../../blocks/navigationmenu/src/NavigationMenu.web";
import AppFooter from "../../../components/src/AppFooter.web";
import FullPageLoader from "../../../components/src/FullPageLoader.web";
import GoogleAd from "../../../components/src/GoogleAd.web";
// Customizable Area End

export default class MyOrders extends MyOrdersController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    // Customizable Area Start
    const { isLoading, orders } = this.state
    // Customizable Area End
    return (
      // Customizable Area Start
      <ThemeProvider theme={theme}>
        <NavigationMenu navigation={this.props.navigation} id={""} />
        <FullPageLoader isLoading={isLoading} />
        <Wrapper>
          <Box>
            <Typography variant="h1" data-test-id="myOrderTitle">
              My Plans
            </Typography>
          </Box>
          <TableContainer
            className="tableContainer"
            sx={{ boxSizing: "border-box" }}
          >
            <Table className="table">
              <TableHead>
                <TableRow className="tableRow">
                  <TableCell className="tableCell">Order number</TableCell>
                  <TableCell className="tableCell">Order Date</TableCell>
                  <TableCell className="tableCell">Valid Till</TableCell>
                  <TableCell className="tableCell">Subscription</TableCell>
                  <TableCell className="tableCell">Total Amount</TableCell>
                  <TableCell className="tableCell">Status</TableCell>
                </TableRow>
              </TableHead>
              {!isLoading && <TableBody>
                {orders.length > 0 ? (
                  orders.map((order, index) => (
                    <TableRow
                      key={index}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell className="tableCell">
                        {order.orderNumber}
                      </TableCell>
                      <TableCell className="tableCell">
                        {order.orderDate}
                      </TableCell>
                      <TableCell className="tableCell">
                        {order.validTill}
                      </TableCell>
                      <TableCell className="tableCell">
                        {order.subscription}
                      </TableCell>
                      <TableCell className="tableCell">
                        ₹{order.totalAmount}
                      </TableCell>
                      <TableCell className="tableCell">
                        {capitalizeFirstLetter(order.status)}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Orders found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>}
            </Table>
          </TableContainer>
          <GoogleAd responsive format="auto" sx={{ mt: 6 }} slot="4645402765" />
        </Wrapper>
        <AppFooter navigation={this.props.navigation} />
      </ThemeProvider>
      // Customizable Area End
    )
  }
}

// Customizable Area Start
const Wrapper = styled("div")(({ theme }) => ({
    backgroundColor: "#EFF6FF",
    display: "flex",
    flexDirection: "column",
    gap: "40.5px",
    justifyContent: "center",
    alignItems: "center",
    padding: "45.5px 100px",
    minHeight: "70vh",
    "@media (max-width: 1024px)": {
      padding: "45.5px 60px",
    },
    "@media (max-width: 800px)": {
      padding: "45.5px 30px",
    },
    "& .tableContainer": {
      backgroundColor: "#FFFFFF",
      border: "1px solid #CBD5E1",
      borderRadius: "12px",
      padding: "50px",
      minHeight: "295px",
      boxSizing: "border-box",
    },

    "& .tableCell": {
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "19.5px",
      color: "#0F172A",
    }
  }));
// Customizable Area End